import EmployeeData from './EmployeeData'

export default EmployeeData